
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import DefaultBackdrop from './default-backdrop';
import DefaultDialog from './default-dialog';
import { useEffect } from 'react';
import DefaultMessage from './default-message';
import axios, { AxiosError } from 'axios';
import { IMessageResponse } from '../model/message-response';
import ApplicationAppService from '../application/platform/application-app-service';
import { BaseLayoutProvider } from './context/base-layout-context';
import { useBaseLayoutController } from './context/base-layout-controller';
import theme from '../theme/theme';
import { useNavigate } from 'react-router-dom';

function BaseLayoutContent({ children }: { children: React.ReactNode }) {
    const applicationData = ApplicationAppService.getApplicationData();
    const { dialogProps, messageProps, loadingProps, showMessage, showLoading } = useBaseLayoutController();
    const navigate = useNavigate();

    const handlerErrorShowMessage = (error: AxiosError) => {
        if (error.response?.status === 500) {
            showMessage({ open: true, message: "Ocorreu uma falha nao tratada na execução.", type: "error" });
            console.log(error.response.data);
            showLoading({ open: false });
        } else if (error.response?.status === 400) {
            var messageResponse = Object.assign({} as IMessageResponse, error.response.data);
            console.log(error.response.data);
            showMessage({ open: true, message: messageResponse.message, type: "error" });
            showLoading({ open: false });
        } else if (error.response?.status === 401) {
            navigate('/?action=login');
        }
    }

    axios.interceptors.response.use((response) => {
        return response;
    }, function (error: AxiosError) {
        handlerErrorShowMessage(error);
    });

    useEffect(() => {
        document.title = applicationData.moduleName;
    }, [applicationData.moduleName]);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <DefaultBackdrop {...loadingProps}></DefaultBackdrop>
                <DefaultMessage {...messageProps}></DefaultMessage>
                <DefaultDialog {...dialogProps}></DefaultDialog>
                {children}
            </Box>
        </ThemeProvider>
    );
}

export default function BaseLayout({ children }: { children: React.ReactNode }) {
    return (
        <BaseLayoutProvider>
            <BaseLayoutContent>
                {children}
            </BaseLayoutContent>
        </BaseLayoutProvider>
    );
}